import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 4 — Talent shell. Sidebar nav + <Outlet/>, reusing the `hr-shell`
 * layout/CSS (mirrors CompensationShell). Coexists with the core /performance
 * module — this is the additive talent + skills layer.
 */

const NAV = [
  { to: '/talent/goals', label: 'Goals & Alignment', testid: 'talent-nav-goals' },
  { to: '/talent/skills', label: 'Skills Cloud', testid: 'talent-nav-skills' },
  { to: '/talent/gap', label: 'Skill Gap', testid: 'talent-nav-gap' },
  { to: '/talent/calibration', label: '9-Box Calibration', testid: 'talent-nav-calibration' },
  { to: '/talent/succession', label: 'Succession', testid: 'talent-nav-succession' },
  { to: '/talent/pools', label: 'Talent Pools', testid: 'talent-nav-pools' },
];

export default function TalentShell() {
  return (
    <div className="hr-shell" data-testid="talent-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Talent</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
